export const environment = {
	production: false,
	oasisApiBase: 'https://02zy3p8lc8.execute-api.us-gov-east-1.amazonaws.com/api',
	cognito: {
		/** Cognito User Pool issuer URL (https://cognito-idp.<region>.amazonaws.com/<poolId>). */
		issuer: 'https://cognito-idp.us-gov-east-1.amazonaws.com/us-gov-east-1_3s3ohsuSy',
		clientId: '6h1t7voma60i841l7e223pijg',
		/**
		 * Cognito user-pools API host, read only by `CognitoSignupService` for the
		 * unauthenticated resend/confirm calls behind `/verify`. FIPS host on purpose,
		 * matching the `auth-fips` domain the discovery document advertises — not
		 * derived from `issuer`, which is the non-FIPS host.
		 */
		idpEndpoint: 'https://cognito-idp-fips.us-gov-east-1.amazonaws.com',
		/**
		 * Hosted UI domain. Informational only — nothing reads this. All OIDC
		 * endpoints are resolved from the discovery document at
		 * `${issuer}/.well-known/openid-configuration`, which advertises the
		 * FIPS host below.
		 */
		hostedDomain: 'https://asb-cap-sam-persistent-dev-oasis-external-v2.auth-fips.us-gov-east-1.amazoncognito.com',
		/**
		 * Space-delimited scopes. Note: Cognito does NOT implement
		 * `offline_access`. Refresh tokens come from the authorization-code
		 * grant regardless, so do not add it — Cognito rejects unknown scopes.
		 */
		scopes: 'openid email profile',
		/**
		 * Must match a registered CallbackURL on the app client exactly.
		 * For local end-to-end testing against the dev pool, temporarily swap
		 * this to 'http://localhost:4200/auth/callback' — dev registers it
		 * (LocalhostRedirect: 'true' in template-persistent.yaml).
		 */
		redirectUri: 'https://ax1-dev.usdoj.gov/auth/callback',
		responseType: 'code',
		/** Bare origin, no trailing slash — must match a registered LogoutURL. */
		postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : '/',
	},
};
